<template>
  <div class="sidebar">
    <div class="sidebarDesktop" v-if="isLogin(menu.isLogin)" v-for="(menu, index) in menus" :key="index">
      <adx-item :items="menu.items" />
    </div>
  </div>
</template>

<script>
import Badge from '@/components/Badge'
import Item from '@/components/SideBar/Desktop/Item'

export default {
  name: `adx-sidebar-desktop`,
  components: {
    'adx-badge': Badge,
    'adx-item': Item
  },
  created() {
    let fullPath = this.$route.fullPath
    let file = null
    if (fullPath.includes("documentation")) {
      file = `/static/data/doc_menus.json`
    } else if (fullPath.includes("admin")) {
      file = `/static/data/admin.json`
    } else if (fullPath.includes("dashboard")) {
      file = `/static/data/dashboard.json`
    } else {
      file = `/static/data/menus.json`
    }
    (async () => {
      let request = await fetch(new Request(file))
      let data = await request.json()
      
      this.menus = data.sidemenus
    })()
  },
  data() {
    return {
      menus: []
    }
  },
  methods: {
    isLogin(isRequired) {
      const token = this.$store.getters.token

      if(isRequired && token) {
        return true
      }else if (isRequired && token == '') {
        return false
      }else {
        return true
      }
    }
  }
}
</script>

<style lang='scss'>
@import "./index.scss";
</style>
